import React from 'react'
import styled, { css } from 'styled-components'
import ButtonShell from 'components/elements/Buttons/ButtonShell'

// Images
import Arrow from 'img/arrow.inline.svg'

export const ButtonPrimaryCSS = css`
  background-color: ${(props) => props.theme.color.primary};
  display: inline-block;
  transition: all 0.3s ease;

  & > a,
  & > button {
    color: ${(props) => props.theme.color.light} !important;
    font-weight: ${({ theme }) => theme.font.weight.bold};
    padding: 10px 15px;
    width: 100%;
    height: 100%;
    display: block;
    text-decoration: none !important;
  }

  &:hover {
    background-color: ${({ theme }) => theme.color.dark};
  }
`

const StyledButton = styled.span`
  ${ButtonPrimaryCSS};
`

const InnerShell = styled.div`
  & svg {
    margin-left: 30px;
    & path {
      fill: ${(props) => props.theme.color.light} !important;
    }
  }
`

interface ButtonPrimaryProps {
  isAnchor?: boolean
  isCustom?: boolean
  to: string
  className?: string
  target?: string
  arrow?: boolean
}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  isAnchor = false,
  isCustom = false,
  to,
  children,
  className = '',
  target = '',
  arrow = true,
}) => (
  <StyledButton className={className}>
    {isCustom ? (
      children
    ) : (
      <ButtonShell to={to} isAnchor={isAnchor} target={target}>
        <InnerShell className="d-flex align-items-center">
          {children}
          {arrow && <Arrow />}
        </InnerShell>
      </ButtonShell>
    )}
  </StyledButton>
)

export default ButtonPrimary
